import { render, staticRenderFns } from "./VaIconNotification.vue?vue&type=template&id=bd41b90a&"
import script from "./VaIconNotification.vue?vue&type=script&lang=js&"
export * from "./VaIconNotification.vue?vue&type=script&lang=js&"
import style0 from "./VaIconNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports